module.exports = __webpack_public_path__ + "img/gfjg.549a1941.svg";